import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { HeroLP1 } from '../components/HeroLP1';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP1() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1392">
      <PriceAlert data-id="element-1393" />
      <HeroLP1 data-id="element-1394" />
      <Testimonial data-id="element-1395" />
      <ProblemSolution data-id="element-1396" />
      <ValueStack data-id="element-1397" />
      <ModuleBreakdown data-id="element-1398" />
      <Guarantee data-id="element-1399" />
      <PricingSection data-id="element-1400" />
      <Footer data-id="element-1401" />
      <RecentPurchaseToast data-id="element-1402" />
    </div>;
}